import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import './index.css';

import App from './App';
import { GlobalProvider } from "./contexts/globalContext"

import CFG_App from './configComponents/CFG_App';
import { GlobalConfigProvider } from "./contexts/globalConfigContext"

import Mobile_App from './mobileComponents/Mobile_App';
import { GlobalMobileProvider } from './contexts/globalMobileContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
        <Routes>
            <Route
                path="/"
                element={
                    <GlobalProvider>
                        <App />
                    </GlobalProvider>
                }
            />

            <Route
                path="/config"
                element={
                    <GlobalConfigProvider>
                        <GlobalProvider>
                            <CFG_App />
                        </GlobalProvider>
                    </GlobalConfigProvider>
                }
            />

            <Route
                path="/mobile"
                element={
                    <GlobalMobileProvider>
                        <GlobalProvider>
                            <Mobile_App />
                        </GlobalProvider>
                    </GlobalMobileProvider>
                }
            />
        </Routes>
    </BrowserRouter>
);


reportWebVitals();
